// extracted by mini-css-extract-plugin
export default {"uploading-loader":"AudioFile_uploading-loader__TKS33","file":"AudioFile_file__K4fpZ","img":"AudioFile_img__+5fhH","progress-bar":"AudioFile_progress-bar__fteDb"};